"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Tab", {
  enumerable: true,
  get: function get() {
    return _tab["default"];
  }
});
Object.defineProperty(exports, "TabList", {
  enumerable: true,
  get: function get() {
    return _tabList["default"];
  }
});
Object.defineProperty(exports, "TabPanel", {
  enumerable: true,
  get: function get() {
    return _tabPanel["default"];
  }
});
Object.defineProperty(exports, "TabPanelList", {
  enumerable: true,
  get: function get() {
    return _tabPanelList["default"];
  }
});
exports["default"] = void 0;
var _tabs = _interopRequireDefault(require("./components/tabs"));
var _tab = _interopRequireDefault(require("./components/tab"));
var _tabList = _interopRequireDefault(require("./components/tab-list"));
var _tabPanelList = _interopRequireDefault(require("./components/tab-panel-list"));
var _tabPanel = _interopRequireDefault(require("./components/tab-panel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _tabs["default"];